(function () {
    'use strict';
    angular.module('mean.accounts-receivable')
        .directive('autocomplete', function ($timeout) {

            return {
                controller: 'autocompleteController',
                restrict: 'E',
                replace: true,
                scope: {
                    choices: '=',
                    enteredtext: '=',
                    minlength: '=',
                    selected: '='
                },
                templateUrl: 'accounts-receivable/directives/temp/autocomplete.html',
              
            }

        }).controller('autocompleteController', ['$scope', function($scope) {

          $scope.filteredChoices = [];
          $scope.isVisible = {
            suggestions: false
          };
          
          $scope.filterItems = function () {
            if($scope.minlength <= $scope.enteredtext.length) {
              $scope.filteredChoices = querySearch($scope.enteredtext);
              $scope.isVisible.suggestions = $scope.filteredChoices.length > 0 ? true : false;
            } else {
              $scope.isVisible.suggestions = false;
            }
          };
          
          
          /**
           * Takes one based index to save selected choice object
           */
          $scope.selectItem = function (index) {
            $scope.selected = $scope.choices[index - 1];
            $scope.enteredtext = $scope.selected.label;
            $scope.isVisible.suggestions = false;
          };
          
          /**
           * Search for states... use $timeout to simulate
           * remote dataservice call.
           */
          function querySearch (query) {
            // returns list of filtered items
            return  query ? $scope.choices.filter( createFilterFor(query) ) : [];
          }
          
          /**
           * Create filter function for a query string
           */
          function createFilterFor(query) {
            var lowercaseQuery = angular.lowercase(query);
        
            return function filterFn(item) {
              // Check if the given item matches for the given query
              var label = angular.lowercase(item.label);
              return (label.indexOf(lowercaseQuery) === 0);
            };
          }
        }]);
})();


// WEBPACK FOOTER //
// ./packages/custom/accounts-receivable/public/directives/autocomplete.js